import React, { useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { Button, Col, Container, Row } from 'reactstrap';
import ToggleButton from "react-toggle-button";
import { addFAQs, addGlossary } from '../../../stores/services/knowledgebase.service';

function AddGlossary(props) {
    const {
        refreshData,
        setRefreshData,
        setAddModalFlag
    } = props
    const [title, setTitle] = useState<string>("")
    const [des, setDes] = useState<string>("")
    const [status, setStatus] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const borderRadiusStyle = { borderRadius: 2 };

    const handleAdd = async () => {
        if (title == "") {
            toast.error("Title field can not be empty")
            return
        }
        if (des == "") {
            toast.error("Description field can not be empty")
            return
        }
        setLoading(false)
        try {
            let res = await addGlossary(
                email,
                amc_code,
                title || "",
                des || "",
                status?.toString()
            )
            if (res.status == 200 && res.data.status == 200) {
                toast.success(res.data.message)
                setRefreshData(!refreshData)
            }
        } catch (error) {
            toast.error("Error Creating Glossary")
        }
        finally {
            setLoading(false)
            setAddModalFlag(false)
        }
    }

    return (
        <Col md="12" className='px-0'>
            <Container fluid>
                <Row>
                    <Col md="12" className='px-0'>
                        <div className="form-group">
                            <label>Title</label>
                            <input
                                className="form-control"
                                placeholder='Enter Title'
                                value={title}
                                onChange={(e) => {
                                    setTitle(e.target.value);
                                }}
                            />
                        </div>
                        {/* {nameError === true ? (
                                  <p className="error-labels">Name is Required.</p>
                                ) : (
                                  ""
                                )} */}
                    </Col>
                    <Col md="12" className='px-0'>
                        <div className="form-group">
                            <label>Description</label>
                            <textarea
                                rows={3}
                                className="form-control"
                                placeholder='Enter Description'
                                value={des}
                                onChange={(e) => {
                                    setDes(e.target.value);
                                }}
                            />
                        </div>
                    </Col>
                    <Col md="12" className='px-0'>
                        <div className="form-group">
                            <label>Status</label>
                            <ToggleButton
                                inactiveLabel=""
                                activeLabel=""
                                value={status}
                                thumbStyle={borderRadiusStyle}
                                trackStyle={borderRadiusStyle}
                                onToggle={() => {
                                    setStatus(!status)
                                }}
                            />
                        </div>
                    </Col>
                </Row>
                <Row className='d-flex justify-content-between'>
                    <Button
                        onClick={() => setAddModalFlag(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => handleAdd()}
                        disabled={loading}
                        color='primary'>
                        Create
                    </Button>
                </Row>
            </Container>
        </Col>
    )
}

export default AddGlossary